module.exports = __webpack_public_path__ + "img/fineness-2@2x.ba3e2d4.webp";